<template>
  <div>
    <post-search v-if="userId && ready"></post-search>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import PostSearch from './postSearch/PostSearch.vue'

  export default {
    components: {
      PostSearch,
    },
    data() {
      return {
        ready: false,
      }
    },
    computed: {
      ...mapState({
        digitalEnabled: state => state.auth.user.prison.purple_post_digital_enabled,
        printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
        filters: state => state.postCard.filters,
        userId: state => state.auth.user.user_id,
      }),
    },
    mounted() {
      if (!this.ready) { // on first load set initial filters
        this.setFiltersFromPrisonPostType();
      }
      this.ready = true;
    },
    methods: {
      setFiltersFromPrisonPostType() {
        this.updateFilter('clinicianId', this.userId);
        this.updateFilter('printOnSite', this.printOnSite)

        // Physical post, no printing
        if (!this.digitalEnabled && !this.printOnSite) {
          this.updateSearchPageFilters({ deliveryStatus: 'sentForPrinting' });
        }

        // Physical post, print on site
        if (!this.digitalEnabled && this.printOnSite) {
          this.updateSearchPageFilters({
            status: 'AwaitingConfirmation',
            sentForPrinting: false,
            dispatched: false,
            delivered: false,
            printOnSite: true,
          });
        }

        // Digital post
        if (this.digitalEnabled) {
          this.updateSearchPageFilters({ status: 'AwaitingConfirmation' });
        }
      },
      updateSearchPageFilters(filters) {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const filtersKey in filters) {
          this.updateFilter(filtersKey, filters[filtersKey]);
        }

        this.$store.commit('postCard/SET_DEFAULT_FILTERS', { ...this.filters }); // set new default filters
      },
      updateFilter(filterName, e) {
        this.$store.commit('postCard/SET_FILTER_ITEM', { name: filterName, value: e });
      },
    },
  }
</script>

<style>

</style>
